import { Button, CircularProgress } from "@mui/material";
import { green, orange, blue } from "@mui/material/colors";
import { SmallScreenDialog, SibaInput, ShowInfoConfirmation, ShowWarningNotification } from "@siba/components";
import { tokenUtil, userManagementUtil, growlWarning } from "@siba/utilities";
import ResetPasswordModalForm from "Application/Pages/AuthForm/ResetPassword/ResetPassword";
import { useGenericFormMethods } from "Application/Pages/formMethods/genericMethods";
import { ILogin } from "Application/features/models/Auth/Login";
import { IResetPassword } from "Application/features/models/Auth/ResetPassword";
import { useSavePasswordResetMutation, useLoginMutation } from "Application/features/services/apis/Auth/AuthAPI";
import { useGetBidderRegisterByUserIdMutation } from "Application/features/services/apis/Home/BidderRegisterApiService";
import { queryResponse } from "Application/features/services/backends/sibaApis";
import React, { useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import "../../AuthForm/Login/Login.css";
import { LoginForm } from "../../../SibaIcons/index";
import { Link } from "react-router-dom";

const UserLoginForm: React.FC = () => {
    const [save] = useSavePasswordResetMutation();
    const [login] = useLoginMutation();
    const [bidderDetails] = useGetBidderRegisterByUserIdMutation();

    const resetPasswordFormMethods = useGenericFormMethods<IResetPassword>({ formName: "Reset Password", saveMethod: save as any });
    const loginFormMethods = useGenericFormMethods<ILogin>({ saveMethod: login as any });
    const {
        //    register,
        formState: { errors }
    } = loginFormMethods.formHandler;

    const loginHandler = () => {
        submitLogin(loginFormMethods.formHandler);
    };

    const easyLogin = (event: any) => {
        if (event.key === 13) {
            console.log("enter");
        }
    };

    const submitLogin = async (formHandler: UseFormReturn<FieldValues, object>) => {
        formHandler.handleSubmit(
            async (data) => {
                setLoading(true);

                const formData = data as ILogin;
                if (login) {
                    const response: queryResponse<any> | any = await login(formData);

                    if (response.data && response.data.user) {
                        let tokenData = response.data;
                        const bidderInfo: queryResponse<any> | any = await bidderDetails(tokenData.user.id);

                        await tokenUtil.setTokenReponse(tokenData);
                        await userManagementUtil.setUserData({ ...tokenData.user, ...bidderInfo.data });
                        setLoading(false);
                        setLoginButtonColor({
                            bgcolor: green[500],
                            "&:hover": {
                                bgcolor: green[700]
                            }
                        });
                        return window.location.assign(window.location.origin + "/sibasalvage/salvage");
                    }
                    setLoading(false);
                    return setLoginButtonColor({
                        bgcolor: orange[500],
                        "&:hover": {
                            bgcolor: orange[700]
                        }
                    });
                }
            },
            (_) => {
                try {
                    growlWarning("please fill required inputs");
                } catch {
                    ShowWarningNotification("please fill required inputs");
                }
            }
        )();
    };

    const resetPassword = async (formHandler: UseFormReturn<FieldValues, object>) => {
        ShowInfoConfirmation("Have you entered the right email ?", async () => {
            await formHandler.handleSubmit(
                async (data) => {
                    const formData = data as IResetPassword;

                    if (save) {
                        const response: queryResponse<any> | any = await save(formData.email);

                        if (response.data) {
                            resetPasswordFormMethods.setOpen(false);
                        }
                    }
                },
                (_) => {
                    try {
                        growlWarning("please fill required inputs");
                    } catch {
                        ShowWarningNotification("please fill required inputs");
                    }
                }
            )();
        });
    };

    const [loading, setLoading] = useState(false);
    const [loginButtonColor, setLoginButtonColor] = React.useState<{
        bgcolor: string;
        "&:hover": {
            bgcolor: string;
        };
    }>({
        bgcolor: blue[500],
        "&:hover": {
            bgcolor: blue[700]
        }
    });

    // const [isLogin, setIsLogin] = useState(true);

    return (
        <>
            <div className="container py-4">
                <div className="row g-0 align-items-center">
                    <div className="col-lg-6 mb-5 mb-lg-0">
                        <div className="card cascading-right" style={{ background: "hsla(0, 0%, 100%, 0.55)", backdropFilter: "blur(30px)", marginRight: "-50px" }}>
                            <div style={{ width: "100%", padding: "20px 80px" }}>
                                <h2 className="heading-9 w-hidden-small w-hidden-tiny loginSignInField" style={{ textAlign: "center", marginTop: "80px", fontWeight: "600", color: "#949494" }}>
                                    Log In To Bid
                                </h2>
                                {/* <h3 className="heading-9 w-hidden-small w-hidden-tiny loginSignInField">
            {isLogin ? 'Log In' : 'Sign Up'} <span className="to-bid-text">To Bid</span>
          </h3> */}

                                <div className="form-bloock w-form">
                                    <form id="loginForm" style={{ width: "100%" }} className="form" method="post" onKeyPress={(e) => e.key === "Enter" && loginHandler()}>
                                        <div className="input-group">
                                            <SibaInput
                                                className="input w-input"
                                                style={{
                                                    boxSizing: "border-box",
                                                    border: "1px solid #F7001F" // Add this line to set the border style
                                                }}
                                                name="username"
                                                label="Username"
                                                formHandler={loginFormMethods.formHandler as any}
                                                type="text"
                                                validationObj={{
                                                    required: true,
                                                    onChange: () => {
                                                        return setLoginButtonColor({
                                                            bgcolor: blue[500],
                                                            "&:hover": {
                                                                bgcolor: blue[700]
                                                            }
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ color: "black" }}>{errors?.userName?.message}</div>

                                        <div className="input-group">
                                            <SibaInput
                                                name="password"
                                                label="Password"
                                                validationObj={{
                                                    required: true,
                                                    onkeypress: (e: React.KeyboardEvent<HTMLInputElement>) => {
                                                        const keycode = e.code ? e.code : "";
                                                        console.log(keycode);
                                                        if (keycode === "Enter") {
                                                            loginHandler();
                                                        }
                                                    },
                                                    onChange: () => {
                                                        return setLoginButtonColor({
                                                            bgcolor: blue[500],
                                                            "&:hover": {
                                                                bgcolor: blue[700]
                                                            }
                                                        });
                                                    }
                                                }}
                                                className="input w-input"
                                                type="password"
                                                id="password"
                                                data-name="password"
                                                formHandler={loginFormMethods.formHandler as any}
                                            />
                                        </div>

                                        <div style={{ color: "black" }}>{errors?.password?.message}</div>
                                        <Button
                                            variant="contained"
                                            sx={loginButtonColor}
                                            style={{ width: "100%", height: "50px", backgroundColor: "#949494" }}
                                            disabled={loading}
                                            onClick={loginHandler}
                                            onKeyDown={(e) => easyLogin(e)}
                                        >
                                            {loading && (
                                                <CircularProgress
                                                    size={24}
                                                    sx={{
                                                        color: green[500],
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        marginTop: "-12px",
                                                        marginLeft: "-12px"
                                                    }}
                                                />
                                            )}
                                            Log In
                                        </Button>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <hr style={{ height: "1px", width: "450%" }} />
                                            <h6 style={{ margin: "0px 15px", fontWeight: "300" }}>OR</h6>
                                            <hr style={{ height: "1px", width: "450%" }} />
                                        </div>
                                        <Link to="/Register">
                                            <Button
                                                variant="contained"
                                                sx={loginButtonColor}
                                                style={{ width: "100%", height: "50px", backgroundColor: "transparent", border: "2px solid #F7001F", color: "#F7001F", boxShadow: "none" }}
                                                disabled={loading}
                                                /*onClick={loginHandler} */ onKeyDown={(e) => easyLogin(e)}
                                            >
                                                {/* {loading && (
                                                            <CircularProgress
                                                                size={24}
                                                                sx={{
                                                                    color: green[500],
                                                                    position: "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    marginTop: "-12px",
                                                                    marginLeft: "-12px"
                                                                }}
                                                            />
                                                        )} */}
                                                Sign Up
                                            </Button>
                                        </Link>
                                    </form>

                                    <div id="spinner" className="m-hide" style={{ marginTop: "1em" }}>
                                        <img style={{ margin: "auto", display: "block" }} src="" />
                                    </div>

                                    <div id="successMessage" className="w-form-done"></div>

                                    <div id="failMessage" className="w-form-fail"></div>

                                    <div id="warningMessage" className="w-form-warning"></div>
                                </div>
                                <div className="div-block-12" style={{ color: "#011641", marginBottom: "50px" }}>
                                    <a className="inlinel1" data-toggle="modal" data-target="#forgetPasswordModal" style={{ color: "#011641" }} onClick={resetPasswordFormMethods.handleClickOpen}>
                                        Forgot your password?
                                    </a>
                                </div>

                                <SmallScreenDialog title="Reset Password" onClose={resetPasswordFormMethods.handleClickClose} visible={resetPasswordFormMethods.modalOpen}>
                                    <ResetPasswordModalForm formHandler={resetPasswordFormMethods.formHandler} save={resetPassword as any} />
                                </SmallScreenDialog>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mb-5 mb-lg-0" style={{ borderRadius: "20px" }}>
                        <img src={LoginForm} className="w-100 rounded-4 shadow-4" alt="" style={{ borderRadius: "20px", height: "73vh", objectFit: "cover" }} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserLoginForm;
